import PropTypes from "prop-types";
import Button from "../Button";
import siteRootRedirect from "../siteRootRedirect";

const HomeButton = ({ className }) => (
  <Button
    action={siteRootRedirect}
    contentKey={"saved_items_api_failure_home_button"}
    className={className}
  />
);

HomeButton.propTypes = {
  className: PropTypes.string
};

export default HomeButton;
